/**
 * Lista estática de tribunais brasileiros com códigos JTR (Resolução CNJ nº 65/2008).
 *
 * Formato do número CNJ: NNNNNNN-DD.AAAA.J.TR.OOOO
 *   J  = ramo de justiça (1 dígito)
 *   TR = tribunal dentro do ramo (2 dígitos)
 *
 * Fonte: https://atos.cnj.jus.br/files/compilado23285720221017634de539229ab.pdf
 * (compilado com alterações até Resolução 477/2022 — inclui TRF6)
 *
 * Tribunais são criados a cada ~30 anos — não justifica tabela/endpoint.
 */

export interface TribunalInfo {
  sigla: string;
  nome: string;
  tipo: 'STF' | 'CNJ' | 'STJ' | 'CJF' | 'TRF' | 'TST' | 'CSJT' | 'TRT' | 'TSE' | 'TRE' | 'STM' | 'CJM' | 'TJ' | 'TJM';
  uf: string | null;
  /** Código JTR conforme Resolução CNJ 65/2008 (ex: "805" = TJBA) */
  jtr: string;
}

export const TRIBUNAIS: TribunalInfo[] = [
  // =====================================================================
  // J=1  Supremo Tribunal Federal
  // =====================================================================
  { sigla: 'STF', nome: 'Supremo Tribunal Federal', tipo: 'STF', uf: null, jtr: '100' },

  // =====================================================================
  // J=2  Conselho Nacional de Justiça
  // =====================================================================
  { sigla: 'CNJ', nome: 'Conselho Nacional de Justiça', tipo: 'CNJ', uf: null, jtr: '200' },

  // =====================================================================
  // J=3  Superior Tribunal de Justiça
  // =====================================================================
  { sigla: 'STJ', nome: 'Superior Tribunal de Justiça', tipo: 'STJ', uf: null, jtr: '300' },

  // =====================================================================
  // J=4  Justiça Federal
  // =====================================================================
  { sigla: 'CJF', nome: 'Conselho da Justiça Federal', tipo: 'CJF', uf: null, jtr: '490' },
  { sigla: 'TRF1', nome: 'Tribunal Regional Federal da 1ª Região', tipo: 'TRF', uf: null, jtr: '401' },
  { sigla: 'TRF2', nome: 'Tribunal Regional Federal da 2ª Região', tipo: 'TRF', uf: null, jtr: '402' },
  { sigla: 'TRF3', nome: 'Tribunal Regional Federal da 3ª Região', tipo: 'TRF', uf: null, jtr: '403' },
  { sigla: 'TRF4', nome: 'Tribunal Regional Federal da 4ª Região', tipo: 'TRF', uf: null, jtr: '404' },
  { sigla: 'TRF5', nome: 'Tribunal Regional Federal da 5ª Região', tipo: 'TRF', uf: null, jtr: '405' },
  { sigla: 'TRF6', nome: 'Tribunal Regional Federal da 6ª Região', tipo: 'TRF', uf: null, jtr: '406' },

  // =====================================================================
  // J=5  Justiça do Trabalho
  // =====================================================================
  { sigla: 'TST', nome: 'Tribunal Superior do Trabalho', tipo: 'TST', uf: null, jtr: '500' },
  { sigla: 'CSJT', nome: 'Conselho Superior da Justiça do Trabalho', tipo: 'CSJT', uf: null, jtr: '590' },
  { sigla: 'TRT1', nome: 'TRT da 1ª Região (Rio de Janeiro)', tipo: 'TRT', uf: 'RJ', jtr: '501' },
  { sigla: 'TRT2', nome: 'TRT da 2ª Região (São Paulo — Capital)', tipo: 'TRT', uf: 'SP', jtr: '502' },
  { sigla: 'TRT3', nome: 'TRT da 3ª Região (Minas Gerais)', tipo: 'TRT', uf: 'MG', jtr: '503' },
  { sigla: 'TRT4', nome: 'TRT da 4ª Região (Rio Grande do Sul)', tipo: 'TRT', uf: 'RS', jtr: '504' },
  { sigla: 'TRT5', nome: 'TRT da 5ª Região (Bahia)', tipo: 'TRT', uf: 'BA', jtr: '505' },
  { sigla: 'TRT6', nome: 'TRT da 6ª Região (Pernambuco)', tipo: 'TRT', uf: 'PE', jtr: '506' },
  { sigla: 'TRT7', nome: 'TRT da 7ª Região (Ceará)', tipo: 'TRT', uf: 'CE', jtr: '507' },
  { sigla: 'TRT8', nome: 'TRT da 8ª Região (Pará e Amapá)', tipo: 'TRT', uf: 'PA', jtr: '508' },
  { sigla: 'TRT9', nome: 'TRT da 9ª Região (Paraná)', tipo: 'TRT', uf: 'PR', jtr: '509' },
  { sigla: 'TRT10', nome: 'TRT da 10ª Região (DF e Tocantins)', tipo: 'TRT', uf: 'DF', jtr: '510' },
  { sigla: 'TRT11', nome: 'TRT da 11ª Região (Amazonas e Roraima)', tipo: 'TRT', uf: 'AM', jtr: '511' },
  { sigla: 'TRT12', nome: 'TRT da 12ª Região (Santa Catarina)', tipo: 'TRT', uf: 'SC', jtr: '512' },
  { sigla: 'TRT13', nome: 'TRT da 13ª Região (Paraíba)', tipo: 'TRT', uf: 'PB', jtr: '513' },
  { sigla: 'TRT14', nome: 'TRT da 14ª Região (Rondônia e Acre)', tipo: 'TRT', uf: 'RO', jtr: '514' },
  { sigla: 'TRT15', nome: 'TRT da 15ª Região (Campinas)', tipo: 'TRT', uf: 'SP', jtr: '515' },
  { sigla: 'TRT16', nome: 'TRT da 16ª Região (Maranhão)', tipo: 'TRT', uf: 'MA', jtr: '516' },
  { sigla: 'TRT17', nome: 'TRT da 17ª Região (Espírito Santo)', tipo: 'TRT', uf: 'ES', jtr: '517' },
  { sigla: 'TRT18', nome: 'TRT da 18ª Região (Goiás)', tipo: 'TRT', uf: 'GO', jtr: '518' },
  { sigla: 'TRT19', nome: 'TRT da 19ª Região (Alagoas)', tipo: 'TRT', uf: 'AL', jtr: '519' },
  { sigla: 'TRT20', nome: 'TRT da 20ª Região (Sergipe)', tipo: 'TRT', uf: 'SE', jtr: '520' },
  { sigla: 'TRT21', nome: 'TRT da 21ª Região (Rio Grande do Norte)', tipo: 'TRT', uf: 'RN', jtr: '521' },
  { sigla: 'TRT22', nome: 'TRT da 22ª Região (Piauí)', tipo: 'TRT', uf: 'PI', jtr: '522' },
  { sigla: 'TRT23', nome: 'TRT da 23ª Região (Mato Grosso)', tipo: 'TRT', uf: 'MT', jtr: '523' },
  { sigla: 'TRT24', nome: 'TRT da 24ª Região (Mato Grosso do Sul)', tipo: 'TRT', uf: 'MS', jtr: '524' },

  // =====================================================================
  // J=6  Justiça Eleitoral
  // =====================================================================
  { sigla: 'TSE', nome: 'Tribunal Superior Eleitoral', tipo: 'TSE', uf: null, jtr: '600' },
  { sigla: 'TRE-AC', nome: 'TRE do Acre', tipo: 'TRE', uf: 'AC', jtr: '601' },
  { sigla: 'TRE-AL', nome: 'TRE de Alagoas', tipo: 'TRE', uf: 'AL', jtr: '602' },
  { sigla: 'TRE-AP', nome: 'TRE do Amapá', tipo: 'TRE', uf: 'AP', jtr: '603' },
  { sigla: 'TRE-AM', nome: 'TRE do Amazonas', tipo: 'TRE', uf: 'AM', jtr: '604' },
  { sigla: 'TRE-BA', nome: 'TRE da Bahia', tipo: 'TRE', uf: 'BA', jtr: '605' },
  { sigla: 'TRE-CE', nome: 'TRE do Ceará', tipo: 'TRE', uf: 'CE', jtr: '606' },
  { sigla: 'TRE-DF', nome: 'TRE do Distrito Federal', tipo: 'TRE', uf: 'DF', jtr: '607' },
  { sigla: 'TRE-ES', nome: 'TRE do Espírito Santo', tipo: 'TRE', uf: 'ES', jtr: '608' },
  { sigla: 'TRE-GO', nome: 'TRE de Goiás', tipo: 'TRE', uf: 'GO', jtr: '609' },
  { sigla: 'TRE-MA', nome: 'TRE do Maranhão', tipo: 'TRE', uf: 'MA', jtr: '610' },
  { sigla: 'TRE-MT', nome: 'TRE de Mato Grosso', tipo: 'TRE', uf: 'MT', jtr: '611' },
  { sigla: 'TRE-MS', nome: 'TRE de Mato Grosso do Sul', tipo: 'TRE', uf: 'MS', jtr: '612' },
  { sigla: 'TRE-MG', nome: 'TRE de Minas Gerais', tipo: 'TRE', uf: 'MG', jtr: '613' },
  { sigla: 'TRE-PA', nome: 'TRE do Pará', tipo: 'TRE', uf: 'PA', jtr: '614' },
  { sigla: 'TRE-PB', nome: 'TRE da Paraíba', tipo: 'TRE', uf: 'PB', jtr: '615' },
  { sigla: 'TRE-PR', nome: 'TRE do Paraná', tipo: 'TRE', uf: 'PR', jtr: '616' },
  { sigla: 'TRE-PE', nome: 'TRE de Pernambuco', tipo: 'TRE', uf: 'PE', jtr: '617' },
  { sigla: 'TRE-PI', nome: 'TRE do Piauí', tipo: 'TRE', uf: 'PI', jtr: '618' },
  { sigla: 'TRE-RJ', nome: 'TRE do Rio de Janeiro', tipo: 'TRE', uf: 'RJ', jtr: '619' },
  { sigla: 'TRE-RN', nome: 'TRE do Rio Grande do Norte', tipo: 'TRE', uf: 'RN', jtr: '620' },
  { sigla: 'TRE-RS', nome: 'TRE do Rio Grande do Sul', tipo: 'TRE', uf: 'RS', jtr: '621' },
  { sigla: 'TRE-RO', nome: 'TRE de Rondônia', tipo: 'TRE', uf: 'RO', jtr: '622' },
  { sigla: 'TRE-RR', nome: 'TRE de Roraima', tipo: 'TRE', uf: 'RR', jtr: '623' },
  { sigla: 'TRE-SC', nome: 'TRE de Santa Catarina', tipo: 'TRE', uf: 'SC', jtr: '624' },
  { sigla: 'TRE-SE', nome: 'TRE de Sergipe', tipo: 'TRE', uf: 'SE', jtr: '625' },
  { sigla: 'TRE-SP', nome: 'TRE de São Paulo', tipo: 'TRE', uf: 'SP', jtr: '626' },
  { sigla: 'TRE-TO', nome: 'TRE de Tocantins', tipo: 'TRE', uf: 'TO', jtr: '627' },

  // =====================================================================
  // J=7  Justiça Militar da União
  // =====================================================================
  { sigla: 'STM', nome: 'Superior Tribunal Militar', tipo: 'STM', uf: null, jtr: '700' },
  { sigla: 'CJM1', nome: '1ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '701' },
  { sigla: 'CJM2', nome: '2ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '702' },
  { sigla: 'CJM3', nome: '3ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '703' },
  { sigla: 'CJM4', nome: '4ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '704' },
  { sigla: 'CJM5', nome: '5ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '705' },
  { sigla: 'CJM6', nome: '6ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '706' },
  { sigla: 'CJM7', nome: '7ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '707' },
  { sigla: 'CJM8', nome: '8ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '708' },
  { sigla: 'CJM9', nome: '9ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '709' },
  { sigla: 'CJM10', nome: '10ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '710' },
  { sigla: 'CJM11', nome: '11ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '711' },
  { sigla: 'CJM12', nome: '12ª Circunscrição Judiciária Militar', tipo: 'CJM', uf: null, jtr: '712' },

  // =====================================================================
  // J=8  Justiça dos Estados e do Distrito Federal e Territórios
  // =====================================================================
  { sigla: 'TJAC', nome: 'Tribunal de Justiça do Acre', tipo: 'TJ', uf: 'AC', jtr: '801' },
  { sigla: 'TJAL', nome: 'Tribunal de Justiça de Alagoas', tipo: 'TJ', uf: 'AL', jtr: '802' },
  { sigla: 'TJAP', nome: 'Tribunal de Justiça do Amapá', tipo: 'TJ', uf: 'AP', jtr: '803' },
  { sigla: 'TJAM', nome: 'Tribunal de Justiça do Amazonas', tipo: 'TJ', uf: 'AM', jtr: '804' },
  { sigla: 'TJBA', nome: 'Tribunal de Justiça da Bahia', tipo: 'TJ', uf: 'BA', jtr: '805' },
  { sigla: 'TJCE', nome: 'Tribunal de Justiça do Ceará', tipo: 'TJ', uf: 'CE', jtr: '806' },
  { sigla: 'TJDFT', nome: 'Tribunal de Justiça do Distrito Federal e Territórios', tipo: 'TJ', uf: 'DF', jtr: '807' },
  { sigla: 'TJES', nome: 'Tribunal de Justiça do Espírito Santo', tipo: 'TJ', uf: 'ES', jtr: '808' },
  { sigla: 'TJGO', nome: 'Tribunal de Justiça de Goiás', tipo: 'TJ', uf: 'GO', jtr: '809' },
  { sigla: 'TJMA', nome: 'Tribunal de Justiça do Maranhão', tipo: 'TJ', uf: 'MA', jtr: '810' },
  { sigla: 'TJMT', nome: 'Tribunal de Justiça de Mato Grosso', tipo: 'TJ', uf: 'MT', jtr: '811' },
  { sigla: 'TJMS', nome: 'Tribunal de Justiça de Mato Grosso do Sul', tipo: 'TJ', uf: 'MS', jtr: '812' },
  { sigla: 'TJMG', nome: 'Tribunal de Justiça de Minas Gerais', tipo: 'TJ', uf: 'MG', jtr: '813' },
  { sigla: 'TJPA', nome: 'Tribunal de Justiça do Pará', tipo: 'TJ', uf: 'PA', jtr: '814' },
  { sigla: 'TJPB', nome: 'Tribunal de Justiça da Paraíba', tipo: 'TJ', uf: 'PB', jtr: '815' },
  { sigla: 'TJPR', nome: 'Tribunal de Justiça do Paraná', tipo: 'TJ', uf: 'PR', jtr: '816' },
  { sigla: 'TJPE', nome: 'Tribunal de Justiça de Pernambuco', tipo: 'TJ', uf: 'PE', jtr: '817' },
  { sigla: 'TJPI', nome: 'Tribunal de Justiça do Piauí', tipo: 'TJ', uf: 'PI', jtr: '818' },
  { sigla: 'TJRJ', nome: 'Tribunal de Justiça do Rio de Janeiro', tipo: 'TJ', uf: 'RJ', jtr: '819' },
  { sigla: 'TJRN', nome: 'Tribunal de Justiça do Rio Grande do Norte', tipo: 'TJ', uf: 'RN', jtr: '820' },
  { sigla: 'TJRS', nome: 'Tribunal de Justiça do Rio Grande do Sul', tipo: 'TJ', uf: 'RS', jtr: '821' },
  { sigla: 'TJRO', nome: 'Tribunal de Justiça de Rondônia', tipo: 'TJ', uf: 'RO', jtr: '822' },
  { sigla: 'TJRR', nome: 'Tribunal de Justiça de Roraima', tipo: 'TJ', uf: 'RR', jtr: '823' },
  { sigla: 'TJSC', nome: 'Tribunal de Justiça de Santa Catarina', tipo: 'TJ', uf: 'SC', jtr: '824' },
  { sigla: 'TJSE', nome: 'Tribunal de Justiça de Sergipe', tipo: 'TJ', uf: 'SE', jtr: '825' },
  { sigla: 'TJSP', nome: 'Tribunal de Justiça de São Paulo', tipo: 'TJ', uf: 'SP', jtr: '826' },
  { sigla: 'TJTO', nome: 'Tribunal de Justiça de Tocantins', tipo: 'TJ', uf: 'TO', jtr: '827' },

  // =====================================================================
  // J=9  Justiça Militar Estadual
  // =====================================================================
  { sigla: 'TJMMG', nome: 'Tribunal de Justiça Militar de Minas Gerais', tipo: 'TJM', uf: 'MG', jtr: '913' },
  { sigla: 'TJMRS', nome: 'Tribunal de Justiça Militar do Rio Grande do Sul', tipo: 'TJM', uf: 'RS', jtr: '921' },
  { sigla: 'TJMSP', nome: 'Tribunal de Justiça Militar de São Paulo', tipo: 'TJM', uf: 'SP', jtr: '926' },
];

/** Mapa JTR → TribunalInfo para lookup rápido a partir do número do processo */
const JTR_MAP = new Map(TRIBUNAIS.map((t) => [t.jtr, t]));

/** Extrai o tribunal a partir de um número CNJ (NNNNNNN-DD.AAAA.J.TR.OOOO) */
export function tribunalFromNumero(numero: string): TribunalInfo | undefined {
  const clean = numero.replace(/[^0-9]/g, '');
  if (clean.length < 20) return undefined;
  const jtr = clean.slice(13, 16); // 3 dígitos JTR
  return JTR_MAP.get(jtr);
}
